import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'cloud-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent {
  @Input() message: string = '';
  @Input() linkText: string = 'Click here';
  @Input() linkUrl: string = '';
  @Output() closed = new EventEmitter<void>();

  close() {
    this.closed.emit();
  }
  
}
